export const API_URL = "/api"
export const PAGE_SIZE = 50

export const BASE_MAP_TILE_URL = "https://{a-c}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}.png"

export const FS_PERMISSIONS = {
  NO_ACCESS: 0,
  READ_FOLDER: 1,
  READ_FILE: 3,
  WRITE_FILE: 5,
  WRITE_FOLDER: 7,
  ADMIN: 9,
} as const
